import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button, Card, CardHeader, CardBody, CardTitle, CardText } from 'reactstrap';
import { useNavigate, useParams, Link } from "react-router-dom";

import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadHoliday, deleteHoliday } from '../../../redux/modules/holidays';

import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';

const HolidayDelete = () => {
    const { holidayId } = useParams();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadHoliday(holidayId));
    }, [ holidayId ]);

    const _deleteHoliday = () => {
        dispatch(deleteHoliday(holidayId));
    }

    const { t } = useTranslation();

    const { holiday, isLoading, holidaySuccessfullyDeleted } = useSelector(state => state.holidays);

    const navigate = useNavigate();
    if (holidaySuccessfullyDeleted)
        return navigate('/holidays/list');

    if (!holiday)
        return null;

    const title =
        <span>
            {t('holidays.holiday')}
            <small> | {t('holidays.delete_holiday', {name: holiday.name})}</small>
        </span>

    const actions =
    <div>
        <ButtonGroup>
            <Button tag={Link} to={ -1 } color="warning" size="sm">
                <i className="fa fa-arrow-left"></i>&nbsp;
                {t('common.back')}
            </Button>
        </ButtonGroup>
    </div>

    const confirmation = t('holidays.confirm_delete_this_profile');
    return (
        <div className="HolidayDelete">
            <PageTitle icon="holidays" title={ title } actions={ actions } />

            {holiday &&
                <Row>
                    <Col>
                        <Card color="light">
                            <CardHeader>
                                <CardTitle tag="h3">
                                    <Icon path={mdiAlertCircleOutline} size={1.5} />
                                    { confirmation }
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <CardText tag="div">
                                    <div><b>{t('holidays.name')}</b>: { holiday.name }</div>
                                    <Row>
                                        <Col className="text-center">
                                            <Button tag={Link} to={ -1 } color="warning">
                                                <i className="fa fa-arrow-left"></i>&nbsp;
                                                {t('common.cancel')}
                                            </Button>&nbsp;
                                            <Button color="danger" onClick={(e) => _deleteHoliday()} disabled={isLoading}>
                                                {isLoading ?
                                                    <span>
                                                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                    </span>
                                                    :
                                                    <span>
                                                        <i className="fa fa-trash"></i>&nbsp;
                                                        {t('common.delete')}
                                                    </span>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
        </div>
    );
}

export default HolidayDelete;
